<template>
    <az-container class="ajusteListagemTabela">
        <az-form>
            <v-data-table :headers="colunas"
                          :items="itens"
                          :loading="false"
                          :options.sync="paginacaoInterna"
                          :server-items-length="totalItens"
                          class="az-table-list tabela-ajuste"
                          hide-default-footer
                          must-sort
                          no-data-text="Não há ajustes disponíveis"
                          @click:row="mostrarDetalhes">
                <template v-slot:item.situacao="{item}">
                    <span>{{item.situacao | azEnum(situacoesAjuste)}}</span>
                </template>

                <template v-slot:item.acesso="{item}">
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span class="mobile">Acessar</span>
                </template>
            </v-data-table>

            <div class="az-pagination">
                <v-pagination
                    v-if="paginas > 1"
                    v-model="paginacaoInterna.page"
                    :length="paginas"/>

                <v-spacer v-if="paginas <= 1"/>

                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
    import {situacoesAjuste} from '@/core/constants'

    export default {
        name: 'AjusteListagemTabela',
        computed: {
            situacoesAjuste() {
                return situacoesAjuste
            }
        },
        components: {},
        props: ['itens', 'paginacao', 'paginas', 'totalItens'],
        data() {
            return {
                colunas: [
                    {
                        text: 'Código',
                        value: 'codigo',
                        sortable: true,
                        align: 'left',
                        width: '10%',
                        class: 'black--text'
                    },
                    {
                        text: 'Tipo',
                        value: 'tipo',
                        sortable: false,
                        align: 'left',
                        width: '30%',
                        class: 'black--text'
                    },
                    {
                        text: 'Órgão',
                        value: 'orgao',
                        sortable: false,
                        align: 'left',
                        width: '10%',
                        class: 'black--text'
                    },
                    {
                        text: 'Conta Contábil',
                        value: 'contaContabil',
                        sortable: false,
                        align: 'left',
                        width: '20%',
                        class: 'black--text'
                    },
                    {
                        text: 'Ano',
                        value: 'ano',
                        sortable: false,
                        align: 'left',
                        width: '10%',
                        class: 'black--text'
                    },
                    {
                        text: 'Situação',
                        value: 'situacao',
                        sortable: false,
                        align: 'left',
                        width: '20%',
                        class: 'black--text'
                    },
                    {
                        text: '',
                        value: 'acesso',
                        sortable: false,
                        align: 'right',
                        width: '20%',
                        class: 'black--text'
                    }
                ],
                paginacaoInterna: this.paginacao,
                linhasPorPagina: [10, 25, 50, 100]
            }
        },
        watch: {
            paginacaoInterna: {
                handler(novoValor) {
                    this.$emit('paginar', novoValor)
                },
                deep: true
            }
        },
        methods: {
            async mostrarDetalhes(ajusteId) {
                await this.$router.push({name: 'AjusteDetalhe', params: {ajusteId: ajusteId.id} })
            }
        }
    }
</script>

<style lang="stylus" >
    .ajusteListagemTabela
        .az-table-list
            .v-input__slot
                border none
                font-size 0.8em
                color black
                border-bottom 1px solid #CCCCCC
                padding-left 0px
                padding-right 0px
                max-height 35px
            .v-input
                padding-top 0px

        .tabela-ajuste
            min-height 62vh !important

        .tabela-ajuste tr > td
            cursor pointer


        .input >>> .v-input__control
            background-color white

        .input >>> .v-input
            max-width 300px


        .v-data-table >>> tbody tr:hover
            cursor pointer !important

        @media (max-width: 720px)
            .az-table-list
                .mobile
                    display inline-block
                    margin-left 3px

</style>

